module.exports = __webpack_public_path__ + "e9d7238c94cc4589ac0ee16c9d7009c9.svg";